import React, { useEffect, useRef, useState } from 'react';

import { Button, Checkbox, Input, IPropsPaging, Paging } from '@ixyberfree/ixybercomponents';
import { GetGuid } from 'components/common/lib';
import styles from './Tables.module.css';

export interface IColumn {
    type: 'text' | 'element' | 'select' | 'number' | 'date' | 'dateTime';
    width: string;
    label: string;
    idCol: string;
    action?: boolean;
}

export interface IFilterItem {
    sortCol: string;
    sortUp: boolean;
    optFilter: IFilterParam[];
}

export interface IFilterParam {
    activ: boolean;
    indCol: string;
    param: string[];
}

export interface IPropsTables {
    header: IColumn[];
    data: any[];
    checked?: string[];
    allChecked?: boolean;
    loading?: boolean;
    width?: string;
    height?: string;
    paging?: boolean;
    actionSort?: boolean;
    actionFilter?: boolean;
    optionPaging?: IPropsPaging;
    optionFilter?: IFilter[];
    indexSort?: number;
    typeSort?: number;
    cssClassHead?: string;
    cssClassBody?: string;
    isFullRender?: boolean;
    onAllCheck?: (check: boolean, array: string[]) => void;
    onCheck?: (item: any, check: boolean) => void;
    onClickItem?: (item: any, col: string) => void;
    onClickRow?: (item: any) => void;
    onDblClickItem?: (item: any, col: string) => void;
    onFilter?: (opt: IFilterItem) => void;
}

const Tables: React.FC<IPropsTables> = ({
    header,
    data,
    loading = false,
    width = '100%',
    height = '100%',
    checked = [],
    paging = false,
    optionPaging,
    optionFilter,
    indexSort,
    typeSort = 0,
    actionSort = true,
    actionFilter = true,
    allChecked,
    cssClassHead = '',
    cssClassBody = '',
    isFullRender = true,
    onCheck,
    onAllCheck,
    onFilter,
    onClickItem,
    onClickRow,
    onDblClickItem
}) => {
    const [selFilter, setSelFilter] = useState<number>(-1);
    const [optFilter, setOptFilter] = useState<IFilter[]>(optionFilter ? optionFilter : createOptionFilter());
    const [sortIndex, setSortIndex] = useState<number>(indexSort ? indexSort : -1);
    const [optSort, setOptSort] = useState<number>(typeSort);
    const [id] = useState<string>(GetGuid());

    useEffect(() => {
        if (optionFilter) setOptFilter(optionFilter);
    }, [optionFilter]);

    function sort(a: any, b: any, indexCol: string) {
        if (optFilter[sortIndex].type == 'date') {
            let itemA: Date = new Date(a[indexCol]);
            let itemB: Date = new Date(b[indexCol]);
            if (itemA < itemB) return -1;
            else return 1;
        } else if (optFilter[sortIndex].type == 'number') {
            let itemA: number = Number.parseInt(a[indexCol]);
            let itemB: number = Number.parseInt(b[indexCol]);
            return itemA - itemB;
        } else if (optFilter[sortIndex].type == 'dateTime') {
            let itemA: Date = new Date(a[indexCol]);
            let itemB: Date = new Date(b[indexCol]);
            if (itemA < itemB) return -1;
            else return 1;
        } else {
            let itemA: string = a[indexCol];
            let itemB: string = b[indexCol];
            if (itemA < itemB) return -1;
            else if (itemA > itemB) return 1;
            else return 0;
        }
    }

    function createOptionFilter() {
        let tempOpt: IFilter[] = [];
        header.forEach(() => {
            let newItem: IFilter = {
                action: false,
                param: [],
                selParam: [],
                type: 'text'
            };
            tempOpt.push(newItem);
        });
        return tempOpt;
    }

    function handleClick(indexItem: string, col: string) {
        if (
            checked.find((elem) => {
                return elem == indexItem;
            }) != undefined
        ) {
            let _item = newData.find((elem) => {
                return elem.id == indexItem;
            });
            if (onCheck) onCheck(_item, false);
            if (onClickItem) onClickItem(_item, col);
        } else {
            let _item = newData.find((elem) => {
                return elem.id == indexItem;
            });
            if (onCheck) onCheck(_item, true);
            if (onClickItem) onClickItem(_item, col);
        }
    }

    function handleClickRow(indexItem: string) {
        let _item = newData.find((elem) => {
            return elem.id == indexItem;
        });
        if (onClickRow) onClickRow(_item);
    }

    function handleDblClick(indexItem: string, col: string) {
        let _item = newData.find((elem) => {
            return elem.id == indexItem;
        });
        if (onDblClickItem) onDblClickItem(_item, col);
    }

    function clickHeaderSelect(allCheck: boolean) {
        let _arr: string[] = [];
        newData.forEach((item, ind) => {
            _arr.push(item.id.toString());
        });
        if (onAllCheck) onAllCheck(allCheck, _arr);
    }

    function clickHeaderFilter(ind: number) {
        if (ind == selFilter) setSelFilter(-1);
        else setSelFilter(ind);
    }

    function handleSelectFilter(opt: string[], index: number) {
        console.debug(index, opt);
        let arrayOpt: IFilter[] = [...optFilter];
        arrayOpt[index].selParam = opt;
        setOptFilter(arrayOpt);
        setSelFilter(-1);
        if (onFilter) {
            let array: IFilterItem = {
                sortCol: sortIndex == -1 ? '' : header[sortIndex].idCol,
                sortUp: optSort > 0,
                optFilter: []
            };
            arrayOpt.forEach((item, ind) => {
                let param: IFilterParam = {
                    activ: item.selParam.length > 0 ? item.action : false,
                    indCol: header[ind].idCol,
                    param: item.selParam
                };
                array.optFilter.push(param);
            });
            onFilter(array);
        }
    }

    function handleSelectSort(type: number, index: number) {
        console.debug(index, type);
        setSortIndex(index);
        setOptSort(type);
        setSelFilter(-1);
        if (onFilter) {
            let array: IFilterItem = {
                sortCol: index == -1 ? '' : header[index].idCol,
                sortUp: type > 0,
                optFilter: []
            };
            optFilter.forEach((item, ind) => {
                let param: IFilterParam = {
                    activ: item.selParam.length > 0 ? item.action : false,
                    indCol: header[ind].idCol,
                    param: item.selParam
                };
                array.optFilter.push(param);
            });
            onFilter(array);
        }
    }

    let viewFoot = <></>;
    if (paging && optionPaging) {
        viewFoot = (
            <tr>
                <td colSpan={header.length}>
                    <Paging
                        maxNumber={optionPaging.maxNumber}
                        selectNumber={optionPaging.selectNumber}
                        onClick={optionPaging.onClick}
                    />
                </td>
            </tr>
        );
    }

    let newData = data.map((item, index) => {
        if (item.id == undefined) {
            item.id = index.toString();
            return item;
        } else {
            return item;
        }
    });

    if (actionFilter) {
        newData = newData.filter((item) => {
            let trueFilter: boolean = true;
            optFilter.forEach((filter, index) => {
                if (trueFilter && filter.action && filter.selParam.length > 0) {
                    let indexCol = header[index].idCol;
                    switch (filter.type) {
                        case 'number': {
                            let itemNum: number = item[indexCol];
                            let min: number = Number.parseInt(filter.selParam[0]);
                            let max: number = Number.parseInt(filter.selParam[1]);
                            trueFilter = itemNum >= min && itemNum <= max;
                            break;
                        }
                        case 'text': {
                            let itemStr: string = item[indexCol];
                            trueFilter = itemStr.indexOf(filter.selParam[0]) > -1;
                            break;
                        }
                        case 'dateTime':
                        case 'date': {
                            let itemDate: number = Date.parse(item[indexCol]);
                            let min: number = Date.parse(filter.selParam[0]);
                            let max: number = Date.parse(filter.selParam[1]);
                            trueFilter = itemDate >= min && itemDate <= max;
                            break;
                        }
                        case 'list': {
                            let itemStr: string = item[indexCol];
                            trueFilter = filter.selParam.indexOf(itemStr) > -1;
                            break;
                        }
                    }
                }
            });
            return trueFilter;
        });
    }

    if (actionSort && sortIndex > -1) {
        let indexCol = header[sortIndex].idCol;

        if (optSort < 0)
            newData.sort((a, b) => {
                return sort(a, b, indexCol);
            });
        else if (optSort > 0) {
            newData.sort((a, b) => {
                return sort(a, b, indexCol);
            });
            newData.reverse();
        }
    }

    const [visibleData, setVisibleData] = useState<any[]>([]);
    const [scrollTop, setScrollTop] = useState(0);
    const containerRef = useRef<HTMLDivElement | null>(null);
    const tableRef = useRef<HTMLTableElement | null>(null);
    const scrollRequestRef = useRef<number | null>(null);

    const [rowHeight, setRowHeight] = useState(30);
    const buffer = 0;

    const handleScroll = () => {
        if (!scrollRequestRef.current) {
            scrollRequestRef.current = requestAnimationFrame(() => {
                if (containerRef.current) {
                    setScrollTop(containerRef.current.scrollTop);
                }
                scrollRequestRef.current = null;
            });
        }
    };

    useEffect(() => {
        const container = containerRef.current;
        if (!container) return;

        container.addEventListener('scroll', handleScroll);
        return () => {
            container.removeEventListener('scroll', handleScroll);
            if (scrollRequestRef.current) {
                cancelAnimationFrame(scrollRequestRef.current);
            }
        };
    }, []);

    useEffect(() => {
        if (isFullRender) {
            setVisibleData(newData);
        } else {
            const height = containerRef.current?.offsetHeight ?? 0;
            const startIndex = Math.max(0, Math.floor(scrollTop / rowHeight) - buffer);
            const endIndex = Math.min(newData.length, Math.ceil((scrollTop + height) / rowHeight) + buffer);
            setVisibleData(newData.slice(startIndex, endIndex));
        }
    }, [scrollTop, data, rowHeight, isFullRender, optSort, optFilter]);

    let _countChecked: number = 0;
    let viewBody = visibleData.map((item, indTR) => {
        let classTr = styles.tr;
        let check = false;
        if (
            checked.length > 0 &&
            checked.find((elem) => {
                return elem == item.id;
            }) != undefined
        ) {
            classTr = classTr + ' ' + styles.check;
            check = true;
            _countChecked++;
        }
        let viewTr = header.map((head: IColumn, ind: number) => {
            let classTd = cssClassBody + ' ' + styles.td; //
            let viewTd = <></>;
            if (head.type == 'select') {
                viewTd = (
                    <Checkbox
                        width="100%"
                        label={''}
                        id={'item' + item.id + check}
                        checked={check}
                        onClick={() => {
                            handleClick(item.id, head.idCol);
                        }}
                        onChange={() => {}}
                    />
                );
                classTd = classTd + ' ' + styles.select;
            } else if (head.type == 'date') {
                let _date = new Date(Date.parse(item[head.idCol]));
                viewTd = <div>{_date.toLocaleString('ru-RU', { dateStyle: 'short' })}</div>;
            } else if (head.type == 'dateTime') {
                let _date = new Date(Date.parse(item[head.idCol]));
                viewTd = <div>{_date.toLocaleString('ru-RU')}</div>;
            } else {
                const innerHtml = item[head.idCol];
                viewTd = (
                    <div
                        style={{
                            overflow: 'hidden',
                            width: '100%',
                            height: '100%',
                            alignItems: 'center',
                            display: 'flex'
                        }}
                        title={typeof innerHtml !== 'object' ? innerHtml : ''}>
                        {innerHtml}
                    </div>
                );
            }

            if (head.type == 'element')
                return (
                    <td
                        className={classTd}
                        id={'body_' + ind}
                        key={'body_' + ind + '_' + indTR}
                        onDoubleClick={() => handleDblClick(item.id, head.idCol)}
                        onClick={() => handleClick(item.id, head.idCol)}
                        dangerouslySetInnerHTML={{ __html: item[head.idCol] }}
                        style={{ width: head.width }}></td>
                );
            else if (head.type == 'select')
                return (
                    <td
                        className={classTd}
                        id={'body_' + ind}
                        key={'body_' + ind + '_' + indTR}
                        style={{ width: head.width }}
                        onClick={(event) => {
                            event.stopPropagation();
                        }}>
                        {viewTd}
                    </td>
                );
            else
                return (
                    <td
                        className={classTd}
                        id={'body_' + ind}
                        key={'body_' + ind + '_' + indTR}
                        onDoubleClick={() => handleDblClick(item.id, head.idCol)}
                        // onClick={() => handleClick(item.id, head.idCol)}
                        style={{ width: head.width }}>
                        {viewTd}
                    </td>
                );
        });
        return (
            <tr
                className={classTr}
                key={indTR}
                onClick={() => {
                    handleClickRow(item.id);
                }}>
                {viewTr}
            </tr>
        );
    });

    let _checkedHead: boolean = false;
    if (_countChecked == newData.length) _checkedHead = true;

    let viewHead = header.map((item: IColumn, index: number) => {
        let classTh = cssClassHead + ' ' + styles.th;
        let viewTh = <></>;
        let viewSVG = <></>;
        let viewFilter = <></>;
        if (actionSort || (actionFilter && optFilter)) {
            viewSVG = (
                <svg width="9" height="5" viewBox="0 0 9 5" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M0.137205 0.774744C-0.280154 0.351336 0.345885 -0.283775 0.798024 0.139632L4.4847 3.87973L8.20616 0.139632C8.62352 -0.283775 9.28434 0.351336 8.86698 0.774744L4.8325 4.86768C4.6586 5.0441 4.34558 5.0441 4.1369 4.86768L0.137205 0.774744Z"
                        fill="currentColor"
                    />
                </svg>
            );
            if (actionSort && sortIndex == index) {
                if (optSort > 0) {
                    viewSVG = (
                        <svg width="9" height="8" viewBox="0 0 9 8" xmlns="http://www.w3.org/2000/svg">
                            <path d="M1 4H5.5" stroke="currentColor" strokeLinecap="round" />
                            <path d="M1 1H8.5" stroke="currentColor" strokeLinecap="round" />
                            <path d="M1 7H3.5" stroke="currentColor" strokeLinecap="round" />
                        </svg>
                    );
                } else if (optSort < 0) {
                    viewSVG = (
                        <svg width="9" height="8" viewBox="0 0 9 8" xmlns="http://www.w3.org/2000/svg">
                            <path d="M1 4H5.5" stroke="currentColor" strokeLinecap="round" />
                            <path d="M1 7H8.5" stroke="currentColor" strokeLinecap="round" />
                            <path d="M1 1H3.5" stroke="currentColor" strokeLinecap="round" />
                        </svg>
                    );
                }
            }
            if (actionFilter && optFilter[index] && optFilter[index].action && optFilter[index].selParam.length > 0) {
                viewSVG = (
                    <svg width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
                        <g clip-path="url(#clip0_1672_5871)">
                            <path
                                d="M12.2339 -2.44081e-05H3.76925C2.79541 -2.44081e-05 2.00156 0.793822 2.00156 1.76767C2.00156 2.23844 2.18618 2.68151 2.51849 3.01844L6.15541 6.65536V10.8877C6.15541 11.5015 6.65387 12 7.26772 12C7.5631 12 7.84926 11.88 8.05695 11.6723L9.44156 10.2877C9.70464 10.0246 9.84772 9.67844 9.84772 9.30921V6.65074L13.4846 3.01382C13.8169 2.68151 14.0016 2.23844 14.0016 1.76767C14.0016 0.793822 13.2077 -2.44081e-05 12.2339 -2.44081e-05ZM12.8293 2.36305L9.19695 5.99998C9.02156 6.17536 8.92464 6.40613 8.92464 6.65536V9.31382C8.92464 9.43382 8.87387 9.55382 8.79079 9.64151L7.40618 11.0261C7.29541 11.1323 7.07849 11.04 7.07849 10.8877V6.65536C7.07849 6.41074 6.98156 6.17536 6.80618 6.00459L3.17387 2.36305C3.01695 2.20613 2.92464 1.98921 2.92464 1.76767C2.92464 1.30151 3.3031 0.923052 3.76925 0.923052H12.2339C12.7 0.923052 13.0785 1.30151 13.0785 1.76767C13.0785 1.98921 12.9862 2.20613 12.8293 2.36305Z"
                                fill="currentColor"
                            />
                            <path
                                fill-rule="evenodd"
                                clip-rule="evenodd"
                                d="M1.85156 1.76767C1.85156 0.710979 2.71257 -0.150024 3.76925 -0.150024H12.2339C13.2906 -0.150024 14.1516 0.710979 14.1516 1.76767C14.1516 2.27842 13.951 2.75959 13.5907 3.11989L9.99772 6.71288V9.30921C9.99772 9.7183 9.83878 10.1026 9.54763 10.3937L8.16301 11.7783C7.92746 12.0139 7.60327 12.15 7.26772 12.15C6.57103 12.15 6.00541 11.5844 6.00541 10.8877V6.71749L2.41242 3.1245L2.41169 3.12377C2.05222 2.7593 1.85156 2.27859 1.85156 1.76767ZM3.76925 0.149976C2.87825 0.149976 2.15156 0.876664 2.15156 1.76767C2.15156 2.19811 2.32 2.6034 2.62492 2.91274L6.30541 6.59323V10.8877C6.30541 11.4187 6.73671 11.85 7.26772 11.85C7.52293 11.85 7.77105 11.7461 7.95088 11.5662L9.3355 10.1816C9.5705 9.9466 9.69772 9.63858 9.69772 9.30921V6.58861L13.3786 2.90776C13.6829 2.60344 13.8516 2.19845 13.8516 1.76767C13.8516 0.876664 13.1249 0.149976 12.2339 0.149976H3.76925ZM3.76925 1.07305C3.38594 1.07305 3.07464 1.38436 3.07464 1.76767C3.07464 1.94828 3.15032 2.12737 3.27994 2.25699L6.91161 5.89789C7.1162 6.09752 7.22849 6.37163 7.22849 6.65536V10.8877C7.22849 10.8877 7.22844 10.8911 7.23258 10.8965C7.23736 10.9026 7.24639 10.9102 7.25932 10.9157C7.27223 10.9212 7.28409 10.9224 7.29208 10.9216C7.29809 10.9209 7.30188 10.9183 7.30188 10.9183L8.68316 9.53702C8.74087 9.47542 8.77464 9.39234 8.77464 9.31382V6.65536C8.77464 6.36593 8.88766 6.09716 9.09081 5.89398L12.7231 2.25705C12.8527 2.12744 12.9285 1.94828 12.9285 1.76767C12.9285 1.38436 12.6172 1.07305 12.2339 1.07305H3.76925ZM2.77464 1.76767C2.77464 1.21867 3.22026 0.773052 3.76925 0.773052H12.2339C12.7829 0.773052 13.2285 1.21867 13.2285 1.76767C13.2285 2.0301 13.1196 2.28482 12.9354 2.46905L9.30308 6.10597C9.15551 6.25355 9.07464 6.44636 9.07464 6.65536V9.31382C9.07464 9.47473 9.00736 9.63101 8.89969 9.74467L8.8969 9.74762L7.50999 11.1345C7.39931 11.2405 7.24841 11.2369 7.14227 11.1919C7.03631 11.147 6.92849 11.0411 6.92849 10.8877V6.65536C6.92849 6.45022 6.84721 6.25391 6.70154 6.11206L6.69997 6.11053L3.0678 2.46912"
                                fill="currentColor"
                            />
                        </g>
                        <defs>
                            <clipPath id="clip0_1672_5871">
                                <rect width="16" height="16" fill="white" />
                            </clipPath>
                        </defs>
                    </svg>
                );
            }

            if (selFilter == index) {
                let filter: IFilter = { action: false, param: [], type: 'text', selParam: [] };
                if (actionFilter) {
                    if (optFilter && optFilter[index]) filter = optFilter[index];
                    switch (item.type) {
                        case 'number': {
                            if (filter.type != 'list') filter.type = 'number';
                            break;
                        }
                        case 'text': {
                            if (filter.type != 'list') filter.type = 'text';
                            break;
                        }
                        case 'date': {
                            if (filter.type != 'list') filter.type = 'date';
                            break;
                        }
                        case 'dateTime': {
                            if (filter.type != 'list') filter.type = 'dateTime';
                            break;
                        }
                    }
                }
                let _optSort: number = 0;
                if (sortIndex == index) _optSort = optSort;

                viewFilter = (
                    <FilterView
                        sort={_optSort}
                        filter={filter}
                        actionSort={actionSort}
                        onSort={(type) => handleSelectSort(type, index)}
                        onApply={(opt) => handleSelectFilter(opt, index)}
                        onCancel={() => setSelFilter(-1)}
                        onResetFilter={() => handleSelectFilter([], index)}
                    />
                );
            }
        }

        switch (item.type) {
            case 'number':
            case 'text':
            case 'dateTime':
            case 'date': {
                if (item.action != undefined) {
                    viewTh = (
                        <div className={styles.th_div}>
                            <div className={styles.th_label}>{item.label}</div>
                            {item.action && (
                                <div className={styles.th_svg} onClick={() => clickHeaderFilter(index)}>
                                    {viewSVG}
                                </div>
                            )}
                        </div>
                    );
                } else {
                    viewTh = (
                        <div className={styles.th_div}>
                            <div className={styles.th_label}>{item.label}</div>
                            <div className={styles.th_svg} onClick={() => clickHeaderFilter(index)}>
                                {viewSVG}
                            </div>
                        </div>
                    );
                }
                break;
            }
            case 'element': {
                viewTh = (
                    <div className={styles.th_div}>
                        <div className={styles.th_label}>{item.label}</div>
                    </div>
                );
                break;
            }
            case 'select': {
                if (allChecked) {
                    viewTh = (
                        <Checkbox
                            width="100%"
                            label={''}
                            id={'header_Checkbox' + index}
                            checked={_checkedHead}
                            onClick={(event) => clickHeaderSelect((event.target as HTMLInputElement).checked)}
                            onChange={() => {}}
                        />
                    );
                } else {
                    viewTh = <div style={{ width: '15px' }}></div>;
                }
                classTh = classTh + ' ' + styles.select;
                break;
            }
        }

        return (
            <th id={'header_' + index} key={'header_' + index} style={{ width: item.width }} className={classTh}>
                {viewFilter}
                {viewTh}{' '}
            </th>
        );
    });

    return (
        <>
            {isFullRender ? (
                <table
                    id={id}
                    style={{ width: width, height: height }}
                    className={styles.table}
                    onClick={() => {
                        if (selFilter > -1) clickHeaderFilter(-1);
                    }}>
                    <thead className={styles.head}>
                        <tr style={{ display: 'flex', width: '100%' }}>{viewHead}</tr>
                    </thead>
                    <tbody style={{ height: `calc(100% - 40px)`, scrollbarGutter: 'auto' }} className={styles.body}>
                        {viewBody}
                    </tbody>
                    {paging && <tfoot className={styles.foot}>{viewFoot}</tfoot>}
                </table>
            ) : (
                <div
                    ref={containerRef}
                    style={{ height, overflowX: 'auto', position: 'relative', fontSize: '14px' }}
                    onClick={() => {
                        if (selFilter > -1) clickHeaderFilter(-1);
                    }}>
                    <table ref={tableRef} style={{ width, height: newData.length * rowHeight }}>
                        <thead className={styles.head}>
                            <tr style={{ display: 'flex' }}>{viewHead}</tr>
                        </thead>
                        <tbody className={styles.body} style={{ overflow: 'hidden' }}>
                            {viewBody}
                        </tbody>
                    </table>
                </div>
            )}
        </>
    );
};

interface IPropsFilterTable {
    actionSort: boolean;
    sort: number;
    filter: IFilter;
    onSort?: (sort: number) => void;
    onFilter?: (selParam: string[]) => void;
    onResetFilter?: () => void;
    onApply?: (selParam: string[]) => void;
    onCancel?: () => void;
}

interface IStateFilterTable {
    param: string[];
    selParam: string[];
    id: string;
}

interface IFilter {
    action: boolean;
    param: string[];
    selParam: string[];
    type: 'number' | 'list' | 'date' | 'text' | 'dateTime';
}

class FilterView extends React.Component<IPropsFilterTable, IStateFilterTable> {
    constructor(props: IPropsFilterTable) {
        super(props);
        this.state = {
            param: this.props.filter.param,
            selParam: this.props.filter.selParam,
            id: GetGuid()
        };
    }
    private onResetFilter() {
        if (this.props.onResetFilter) this.props.onResetFilter();
        this.setState({ selParam: [] });
    }

    private OnChange(item: string, index: number) {
        let selParamTemp: string[] = [...this.state.selParam];
        selParamTemp[index] = item;
        this.setState({ selParam: selParamTemp });
    }

    render() {
        let heightFilter = '0px';
        if (this.props.filter.action && this.props.actionSort) heightFilter = '180px';
        else if (this.props.filter.action) heightFilter = '85px';
        else if (this.props.actionSort) heightFilter = '80px';
        else heightFilter = '0px';
        let viewFilter = <></>;
        let viewSort = <></>;
        if (this.props.filter.action) {
            let viewOptFilter = <></>;
            switch (this.props.filter.type) {
                case 'number': {
                    viewOptFilter = (
                        <div className={styles.filter_but}>
                            <Input
                                type={'number'}
                                width="100px"
                                defaultValue={this.state.selParam[0]}
                                onBlur={(event) => {
                                    this.OnChange(event.target.value, 0);
                                }}
                                onKeyDown={(event) => {
                                    if (event.key === 'Enter') {
                                        event.currentTarget.blur();
                                    }
                                }}
                            />
                            <Input
                                type={'number'}
                                width="100px"
                                defaultValue={this.state.selParam[1]}
                                onBlur={(event) => {
                                    this.OnChange(event.target.value, 1);
                                }}
                                onKeyDown={(event) => {
                                    if (event.key === 'Enter') {
                                        event.currentTarget.blur();
                                    }
                                }}
                            />
                        </div>
                    );
                    break;
                }
                case 'text': {
                    viewOptFilter = (
                        <div className={styles.filter_but}>
                            <Input
                                type={'text'}
                                width="200px"
                                defaultValue={this.state.selParam[0]}
                                onBlur={(event) => {
                                    this.OnChange(event.target.value, 0);
                                }}
                                onKeyDown={(event) => {
                                    if (event.key === 'Enter') {
                                        event.currentTarget.blur();
                                    }
                                }}
                            />
                        </div>
                    );
                    break;
                }
                case 'date': {
                    viewOptFilter = (
                        <div className={styles.filter_but}>
                            <input
                                style={{ width: '100px' }}
                                type={'date'}
                                onChange={(event) => {
                                    this.OnChange(event.currentTarget.value, 0);
                                }}
                                value={this.state.selParam[0]}
                            />
                            <input
                                style={{ width: '100px' }}
                                type={'date'}
                                onChange={(event) => {
                                    this.OnChange(event.currentTarget.value, 1);
                                }}
                                value={this.state.selParam[1]}
                            />
                        </div>
                    );
                    break;
                }
                case 'dateTime': {
                    viewOptFilter = (
                        <div className={styles.filter_but}>
                            <input
                                style={{ width: '100px' }}
                                type={'datetime-local'}
                                onChange={(event) => {
                                    this.OnChange(event.currentTarget.value, 0);
                                }}
                                value={this.state.selParam[0]}
                            />
                            <input
                                style={{ width: '100px' }}
                                type={'datetime-local'}
                                onChange={(event) => {
                                    this.OnChange(event.currentTarget.value, 1);
                                }}
                                value={this.state.selParam[1]}
                            />
                        </div>
                    );
                    break;
                }
                case 'list': {
                    heightFilter = '250px';
                    let viewArray = this.state.param.map((item, index) => {
                        let check = false;
                        if (this.state.selParam.indexOf(item) > -1) check = true;
                        return (
                            <div className={styles.filter_listItem} key={`filterItem-${index}`}>
                                <Checkbox
                                    width="120%"
                                    label={item}
                                    id={'FilterItem' + index}
                                    checked={check}
                                    onClick={(event) => {
                                        const checked = (event.target as HTMLInputElement).checked;
                                        this.OnChange(checked ? item : '', index);
                                    }}
                                    onChange={() => {}}
                                />
                            </div>
                        );
                    });
                    viewOptFilter = <div className={styles.filter_divItem}>{viewArray}</div>;
                    break;
                }
            }

            viewFilter = (
                <>
                    {this.props.actionSort && (
                        <div
                            style={{
                                border: '1px solid #DCDCDC',
                                transform: 'rotate(0deg)',
                                margin: '5px 10px 5px 10px'
                            }}></div>
                    )}
                    <div className={styles.filter_but_main} onClick={() => this.onResetFilter()}>
                        <svg width="13" height="14" viewBox="0 0 13 14" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M2.14132 2.36698C2.29097 2.16744 2.52583 2.05001 2.77525 2.05001H9.84643C10.1145 2.05001 10.3669 2.17622 10.5277 2.39067C10.7689 2.71227 10.7524 3.15875 10.4881 3.46163L8.58837 5.63837C8.38864 5.86723 8.41225 6.21466 8.64111 6.4144C8.86997 6.61413 9.21741 6.59051 9.41714 6.36166L11.3168 4.18492C11.9226 3.49083 11.9605 2.46767 11.4077 1.73067C11.0392 1.23923 10.4607 0.950012 9.84643 0.950012H2.77525C2.1796 0.950012 1.61871 1.23046 1.26132 1.70698C0.696258 2.46039 0.771183 3.51464 1.43711 4.18057L4.49081 7.23427V11.4116C4.49081 11.7154 4.73705 11.9616 5.04081 11.9616C5.34456 11.9616 5.59081 11.7154 5.59081 11.4116V7.1135C5.59081 6.89909 5.50563 6.69346 5.35402 6.54184L2.21493 3.40275C1.93608 3.12391 1.90471 2.68245 2.14132 2.36698Z"
                                fill="#AEAEAE"
                            />
                            <path
                                d="M7.69969 8.11445L10.0032 10.421L12.3074 8.11526C12.3843 8.041 12.4871 7.99991 12.5939 8.00084C12.7007 8.00177 12.8028 8.04465 12.8784 8.12023C12.9539 8.19581 12.9967 8.29806 12.9976 8.40495C12.9986 8.51184 12.9575 8.61482 12.8833 8.6917L10.579 10.9975L12.8833 13.3032C12.9212 13.3411 12.9512 13.3861 12.9717 13.4356C12.9922 13.4852 13.0028 13.5382 13.0028 13.5918C13.0028 13.6454 12.9922 13.6985 12.9717 13.748C12.9512 13.7976 12.9212 13.8426 12.8833 13.8805C12.8455 13.9184 12.8005 13.9484 12.751 13.9689C12.7016 13.9895 12.6485 14 12.595 14C12.5414 14 12.4884 13.9895 12.4389 13.9689C12.3895 13.9484 12.3445 13.9184 12.3066 13.8805L10.0032 11.5739L7.69887 13.8805C7.6224 13.957 7.51868 14 7.41053 14C7.30238 14 7.19866 13.957 7.12219 13.8805C7.04571 13.8039 7.00275 13.7001 7.00275 13.5918C7.00275 13.4836 7.04571 13.3798 7.12219 13.3032L9.42648 10.9975L7.12382 8.69089C7.04963 8.614 7.00858 8.51102 7.00951 8.40414C7.01044 8.29725 7.05327 8.195 7.12878 8.11941C7.20429 8.04383 7.30643 8.00096 7.41322 8.00003C7.52 7.9991 7.62287 8.04019 7.69969 8.11445Z"
                                fill="#AEAEAE"
                            />
                        </svg>
                        <label className={styles.filter_but_label}>Сбросить фильтр</label>
                    </div>
                    {viewOptFilter}
                    <div className={styles.filter_but} style={{ paddingTop: '5px' }}>
                        <Button
                            text="Применить"
                            styleType="filled"
                            size="small"
                            onClick={() => {
                                if (this.props.onApply) this.props.onApply(this.state.selParam);
                            }}
                        />
                        <Button
                            text="Отменить"
                            styleType="tinted"
                            size="small"
                            onClick={() => {
                                if (this.props.onCancel) this.props.onCancel();
                            }}
                        />
                    </div>
                </>
            );
        }
        if (this.props.actionSort) {
            let _textNext = 'По возрастанию';
            let _textBack = 'По убыванию';
            switch (this.props.filter.type) {
                case 'number': {
                    _textNext = 'По возрастанию';
                    _textBack = 'По убыванию';
                    break;
                }
                case 'text': {
                    _textNext = 'от А до Я';
                    _textBack = 'от Я до А';
                    break;
                }
                case 'dateTime':
                case 'date': {
                    _textNext = 'Сначала старые';
                    _textBack = 'Сначала новые';
                    break;
                }
            }

            viewSort = (
                <>
                    <div
                        className={styles.filter_but_main}
                        style={{ paddingTop: '5px' }}
                        onClick={() => {
                            if (this.props.onSort) this.props.onSort(0);
                        }}>
                        <svg width="13" height="14" viewBox="0 0 13 14" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M2.14132 2.36698C2.29097 2.16744 2.52583 2.05001 2.77525 2.05001H9.84643C10.1145 2.05001 10.3669 2.17622 10.5277 2.39067C10.7689 2.71227 10.7524 3.15875 10.4881 3.46163L8.58837 5.63837C8.38864 5.86723 8.41225 6.21466 8.64111 6.4144C8.86997 6.61413 9.21741 6.59051 9.41714 6.36166L11.3168 4.18492C11.9226 3.49083 11.9605 2.46767 11.4077 1.73067C11.0392 1.23923 10.4607 0.950012 9.84643 0.950012H2.77525C2.1796 0.950012 1.61871 1.23046 1.26132 1.70698C0.696258 2.46039 0.771183 3.51464 1.43711 4.18057L4.49081 7.23427V11.4116C4.49081 11.7154 4.73705 11.9616 5.04081 11.9616C5.34456 11.9616 5.59081 11.7154 5.59081 11.4116V7.1135C5.59081 6.89909 5.50563 6.69346 5.35402 6.54184L2.21493 3.40275C1.93608 3.12391 1.90471 2.68245 2.14132 2.36698Z"
                                fill="#AEAEAE"
                            />
                            <path
                                d="M7.69969 8.11445L10.0032 10.421L12.3074 8.11526C12.3843 8.041 12.4871 7.99991 12.5939 8.00084C12.7007 8.00177 12.8028 8.04465 12.8784 8.12023C12.9539 8.19581 12.9967 8.29806 12.9976 8.40495C12.9986 8.51184 12.9575 8.61482 12.8833 8.6917L10.579 10.9975L12.8833 13.3032C12.9212 13.3411 12.9512 13.3861 12.9717 13.4356C12.9922 13.4852 13.0028 13.5382 13.0028 13.5918C13.0028 13.6454 12.9922 13.6985 12.9717 13.748C12.9512 13.7976 12.9212 13.8426 12.8833 13.8805C12.8455 13.9184 12.8005 13.9484 12.751 13.9689C12.7016 13.9895 12.6485 14 12.595 14C12.5414 14 12.4884 13.9895 12.4389 13.9689C12.3895 13.9484 12.3445 13.9184 12.3066 13.8805L10.0032 11.5739L7.69887 13.8805C7.6224 13.957 7.51868 14 7.41053 14C7.30238 14 7.19866 13.957 7.12219 13.8805C7.04571 13.8039 7.00275 13.7001 7.00275 13.5918C7.00275 13.4836 7.04571 13.3798 7.12219 13.3032L9.42648 10.9975L7.12382 8.69089C7.04963 8.614 7.00858 8.51102 7.00951 8.40414C7.01044 8.29725 7.05327 8.195 7.12878 8.11941C7.20429 8.04383 7.30643 8.00096 7.41322 8.00003C7.52 7.9991 7.62287 8.04019 7.69969 8.11445Z"
                                fill="#AEAEAE"
                            />
                        </svg>
                        <label className={styles.filter_but_label}>Сбросить сортировку</label>
                    </div>
                    <div
                        className={styles.filter_but_main}
                        onClick={() => {
                            if (this.props.onSort) this.props.onSort(-1);
                        }}>
                        <svg width="9" height="8" viewBox="0 0 9 8" xmlns="http://www.w3.org/2000/svg">
                            <path d="M1 4H5.5" stroke="currentColor" strokeLinecap="round" />
                            <path d="M1 7H8.5" stroke="currentColor" strokeLinecap="round" />
                            <path d="M1 1H3.5" stroke="currentColor" strokeLinecap="round" />
                        </svg>
                        <label>{_textNext}</label>
                    </div>
                    <div
                        className={styles.filter_but_main}
                        onClick={() => {
                            if (this.props.onSort) this.props.onSort(1);
                        }}>
                        <svg width="9" height="8" viewBox="0 0 9 8" xmlns="http://www.w3.org/2000/svg">
                            <path d="M1 4H5.5" stroke="currentColor" strokeLinecap="round" />
                            <path d="M1 1H8.5" stroke="currentColor" strokeLinecap="round" />
                            <path d="M1 7H3.5" stroke="currentColor" strokeLinecap="round" />
                        </svg>
                        <label>{_textBack}</label>
                    </div>
                </>
            );
        }

        return (
            <div
                key={this.state.id}
                className={styles.main_filter}
                style={{ width: `220px`, height: heightFilter }}
                onClick={(event) => event.stopPropagation()}>
                {viewSort}
                {viewFilter}
            </div>
        );
    }
}

export default Tables;
